import {ModuleProto} from "../module-proto";
import {ModuleType} from "../types";
import {RequestFormType} from "../../../app/tools/request-forms2/const/const";
import {SettingsMenuTopCategory} from "../settings-module";
import {Feature} from "../../gd/access-control/feature-access/const";
import {SettingsParentSection} from "../../../app/settings/const";

// const debug = "ExpensesModule"
const debug = false

export class LaborCostModule extends ModuleProto {

    // public tasks        : boolean       // when true - user can submit toward tasks
    // public taskView        : boolean       // when true - user can submit toward tasks

    constructor(moduleConfig:JSONObject) {
        super(ModuleType.LABOR_COST, moduleConfig);

        debug && console.log(debug, "constructor() moduleConfig=",moduleConfig)

        this.name                       = "Labor Cost"
        this.description                = "The Labor Cost module enables automatic calculation of your organization's labor and/or professional service costs based on users' time reports and associated hourly rates."
        this.typeLabel                  = "Billing & Finance"
        this.svgIcon                    = "isvg labor-cost"
        this.settingsMenuTopCategory    = SettingsMenuTopCategory.ORGANIZATION
        this.canDisable                 = false
        this._isEnabled                 = true // because this.canDisable false
        this.settingsUrl                = "settings/labor-cost"
        this.parentSection              = SettingsParentSection.FINANCE

        this.feature                    = Feature.FINANCE
        this.validateFeature()

        debug && console.log(debug, "_isEnabled", this._isEnabled)
    }

    get trackInternalCost():boolean {
        return gd.company.trackInternalCosts()
    }

    get defaultInternalCost() {
        return gd.company.financeDefaultInternalCost
    }

    get trackExternalCost():boolean {
        return gd.company.trackExternalCosts()
    }

    get defaultExternalCost() {
        return gd.company.financeDefaultExternalCost
    }

    disable = ():void => {
        console.warn("Labor cost module always enabled as it is old one")
    }

    toJson() {
        debug && console.log(debug, "toJson() type=",this.type, "_isEnabled=", this._isEnabled)

        // const result = super.toJson();
        const result = {}

        debug && console.log(debug, "    newConfig=", result)

        return result
    }

    goToSettings() {
        gd.goTo('settings/labor-cost'.f(gd.companyId))
    }


}
